(function(){
  var MAX_FILES=4, MAX_TOTAL_BYTES=10*1024*1024, UPLOAD_VARIANT_ID='59246978629977';

  function filesOf(input){return input?[].slice.call(input.files||[]):[];}
  function totalBytes(list){return list.reduce(function(s,f){return s+(f.size||0);},0);}
  function abs(v){if(!v)return '';v=String(v);if(v.indexOf('//')===0)return 'https:'+v;if(v.charAt(0)==='/')return location.origin+v;return v;}
  function propUrl(props){var v=props&&props['Photo d’inspiration'];if(Array.isArray(v))v=v[0];v=abs(v);return /^https?:\/\//i.test(v)?v:'';}

  function removeLegacyMailCard(){
    document.querySelectorAll('.ltz-quote-side-card h2').forEach(function(h){
      if((h.textContent||'').trim().toLowerCase()==='photos d’inspiration'){
        var card=h.closest('.ltz-quote-side-card');
        if(card)card.remove();
      }
    });
  }

  function uploadOne(file){
    var d=new FormData();
    d.append('id',UPLOAD_VARIANT_ID);
    d.append('quantity','1');
    d.append('properties[Photo d’inspiration]',file,file.name);
    d.append('properties[Usage]','Demande de devis');
    return fetch('/cart/add.js',{method:'POST',body:d,headers:{Accept:'application/json'}})
      .then(function(r){if(!r.ok)throw 0;return r.json();})
      .then(function(item){
        var u=propUrl(item.properties);
        if(u)return u;
        return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(cart){
          var items=cart.items||[];
          for(var i=items.length-1;i>=0;i--){
            if(String(items[i].variant_id)===UPLOAD_VARIANT_ID&&items[i].properties&&items[i].properties['Usage']==='Demande de devis'){
              var x=propUrl(items[i].properties);if(x)return x;
            }
          }
          throw 0;
        });
      });
  }

  function ensureShopify(form){
    if(!form)return;
    if((form.getAttribute('action')||'').indexOf('formsubmit.co')!==-1)form.setAttribute('action','/contact#'+form.id);
    form.setAttribute('method','post');
    form.querySelectorAll('input[name^="_"]').forEach(function(el){el.remove();});
    var old=form.querySelector('input[name="contact[Photos d’inspiration]"]');if(old)old.remove();
    if(!form.querySelector('input[name="form_type"]')){var a=document.createElement('input');a.type='hidden';a.name='form_type';a.value='contact';form.prepend(a);}
    if(!form.querySelector('input[name="utf8"]')){var b=document.createElement('input');b.type='hidden';b.name='utf8';b.value='✓';form.prepend(b);}
  }

  function ensureUpload(form){
    var input=document.getElementById('LtzQuotePhotos');
    if(input)return input;
    var ta=form.querySelector('textarea[name="contact[body]"]');
    var target=ta&&(ta.closest('.ltz-quote-field')||ta.parentElement);
    if(!target)return null;
    var w=document.createElement('div');
    w.id='LtzQuoteUploadWrap';
    w.className='ltz-quote-field ltz-quote-field--full';
    w.style.gridColumn='1 / -1';
    w.innerHTML='<span class="ltz-quote-label" style="display:block;margin-bottom:8px">Photos d’inspiration</span><label for="LtzQuotePhotos" style="position:relative;display:flex;min-height:190px;padding:24px 18px;align-items:center;justify-content:center;flex-direction:column;border:1.5px dashed #c7a897;border-radius:18px;background:#fffaf6;text-align:center;cursor:pointer"><input id="LtzQuotePhotos" type="file" accept="image/*" multiple style="position:absolute;width:1px;height:1px;opacity:0"><span style="display:grid;width:46px;height:46px;margin-bottom:11px;place-items:center;border-radius:50%;background:#762942;color:#fff;font-size:27px">+</span><strong>Ajouter mes photos d’inspiration</strong><small style="margin-top:6px">Jusqu’à 4 photos · 10 Mo maximum au total</small><em id="LtzQuotePhotoNames" style="margin-top:10px;color:#762942;font-size:11px;font-style:normal;font-weight:750">Aucune photo sélectionnée</em></label><div id="LtzQuotePhotoError" style="display:none;margin-top:10px;color:#962a44;font-size:12px"></div>';
    target.insertAdjacentElement('beforebegin',w);
    return document.getElementById('LtzQuotePhotos');
  }

  function bind(form,input,names,error,status,submit){
    if(!form||form.dataset.ltzPhotoMailReady==='true')return;
    form.dataset.ltzPhotoMailReady='true';
    ensureShopify(form);
    var ta=form.querySelector('textarea[name="contact[body]"]');
    if(!ta||!input)return;
    var userMessage=ta.value||'';
    ta.addEventListener('input',function(){if(form.dataset.ltzInjecting!=='true')userMessage=ta.value;});
    function show(t){if(error){error.textContent=t||'';error.style.display=t?'block':'none';}if(status)status.textContent=t||'';}
    function refresh(){
      var l=filesOf(input);
      if(names)names.textContent=l.length?l.map(function(f){return f.name;}).join(' · '):'Aucune photo sélectionnée';
      if(l.length>MAX_FILES)show('Vous pouvez ajouter jusqu’à 4 photos maximum.');
      else if(totalBytes(l)>MAX_TOTAL_BYTES)show('Les photos dépassent 10 Mo au total.');
      else show('');
    }
    input.addEventListener('change',refresh);
    form.addEventListener('submit',function(e){
      if(form.dataset.ltzNativeGo==='true'){ensureShopify(form);return;}
      var l=filesOf(input);
      if(!l.length){ensureShopify(form);form.dataset.ltzNativeGo='true';return;}
      e.preventDefault();e.stopImmediatePropagation();
      if(l.length>MAX_FILES){show('Vous pouvez ajouter jusqu’à 4 photos maximum.');return;}
      if(totalBytes(l)>MAX_TOTAL_BYTES){show('Les photos dépassent 10 Mo au total.');return;}
      if(submit){submit.disabled=true;submit.dataset.oldText=submit.textContent;submit.textContent='Envoi des photos…';}
      show('Envoi des photos…');
      l.reduce(function(p,f){return p.then(function(urls){return uploadOne(f).then(function(u){urls.push(u);return urls;});});},Promise.resolve([]))
      .then(function(urls){
        var photoText='PHOTOS D’INSPIRATION\n'+urls.map(function(u,i){return 'Photo '+(i+1)+' : '+u;}).join('\n');
        form.dataset.ltzInjecting='true';
        ta.value=(userMessage||'').replace(/\s+$/,'')+'\n\n------------------------------\n'+photoText;
        form.dataset.ltzInjecting='false';
        var duplicate=form.querySelector('input[name="contact[Photos d’inspiration]"]');if(duplicate)duplicate.remove();
        ensureShopify(form);form.dataset.ltzNativeGo='true';
        if(submit){submit.disabled=false;submit.textContent=submit.dataset.oldText||'Envoyer ma demande';}
        show('Demande envoyée avec les liens photos…');
        if(typeof form.requestSubmit==='function'&&submit)form.requestSubmit(submit);else form.submit();
      })
      .catch(function(){
        if(submit){submit.disabled=false;submit.textContent=submit.dataset.oldText||'Envoyer ma demande';}
        show('La photo n’a pas pu être envoyée. Réessayez avec une image plus légère.');
      });
    },true);
  }

  function init(){
    if((location.pathname||'').toLowerCase().indexOf('/pages/demande-de-devis')===-1)return;
    removeLegacyMailCard();
    var q=document.getElementById('LtzQuoteForm');
    if(q){
      var qi=ensureUpload(q);
      bind(q,qi,document.getElementById('LtzQuotePhotoNames'),document.getElementById('LtzQuotePhotoError'),null,q.querySelector('.ltz-quote-submit,button[type="submit"],input[type="submit"]'));
    }
    var d=document.getElementById('LtzDevisForm');
    if(d)bind(d,document.getElementById('LtzDevisPhotos'),document.getElementById('LtzDevisPhotoNames'),null,document.getElementById('LtzDevisStatus'),document.getElementById('LtzDevisSubmit')||d.querySelector('button[type="submit"]'));
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();